import React from 'react';
import ReactDOM from 'react-dom/client';
import alertify from 'alertifyjs';

import './index.css';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';

import { App } from './App';
import { reportWebVitals } from './reportWebVitals';

import './configurations/i18n';

alertify.defaults.glossary.title = '';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <React.Suspense fallback="Loading...">
        <App />
    </React.Suspense>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
